import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { AlertBox, Box } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import ItemDocumentConversionFailureModal from '../ItemDocumentConversionFailureModal';
import { LineItemReorderActionStatusContext } from '../../contexts/LineItemReorderActionStatusContext';
import { BUY_IT_AGAIN_SOURCE_PAGE } from '../../../constants/orderdetailsui';
import { CheckoutCta } from './CheckoutCta';

export const LineItemReorderActionFeedback = ({ sourcePageOverride }) => {
  const [
    errorMessages,
    buyItAgainMessages,
    orderDetailsMessages,
    orderabilityMessages,
  ] = useTranslations([
    'errorMessages',
    'buyItAgainMessages',
    'orderDetailsMessages',
    'orderabilityMessages',
  ]);

  const {
    addToCartSuccess,
    addToCartFailure,
    productUnavailableFailure,
    docConversionFailure,
    designUpdateInProgress,
    genericFailure,
  } = useContext(LineItemReorderActionStatusContext);

  if (designUpdateInProgress) {
    return (
      <AlertBox skin="standard" my={3}>
        {buyItAgainMessages.designUpdateInProgress}
      </AlertBox>
    );
  }

  if (addToCartFailure) {
    return (
      <AlertBox skin="error" my={3}>
        {errorMessages.addToCartFailure}
      </AlertBox>
    );
  }

  if (addToCartSuccess) {
    return (
      <AlertBox skin="positive" my={3}>
        {orderDetailsMessages.addToCartSuccessMessage}
        {sourcePageOverride === BUY_IT_AGAIN_SOURCE_PAGE && (
          <Box>
            <CheckoutCta sourcePage={BUY_IT_AGAIN_SOURCE_PAGE} />
          </Box>
        )}
      </AlertBox>
    );
  }

  if (productUnavailableFailure) {
    return (
      <AlertBox skin="warning" my={3}>
        {orderabilityMessages.productNoLongerAvailable}
      </AlertBox>
    );
  }

  if (docConversionFailure) {
    return <ItemDocumentConversionFailureModal isOpen={docConversionFailure} />;
  }

  if (genericFailure) {
    return (
      <AlertBox skin="error" my={3}>
        {errorMessages.defaultErrorDetails}
      </AlertBox>
    );
  }

  return null;
};

LineItemReorderActionFeedback.propTypes = {
  sourcePageOverride: PropTypes.string,
};
